import * as React from "react"
import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"

const Header = ({ siteTitle }) => (
  <header
    style={
      {
        // background: `rebeccapurple`,
        // marginBottom: `1.45rem`,
      }
    }
  >
    <StaticImage
      src="../images/Engagement-Wish-logo-blue.png"
      width={300}
      quality={95}
      formats={["AUTO", "WEBP", "AVIF"]}
      alt="Engagement Wish logo"
    />
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
